<template>
  <v-card
    flat
    class="pa-2 white"
  >
    <v-card-text>
      <base-info-card
        v-if="title"
        :title="title"
        :subtitle="subtitle"
        space="4"
        color="primary"
      />
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <base-text-field
            v-model="contract_number"
            label="Номер договора"
          />
          <base-textarea
            v-model="comment"
            class="mb-1"
            label="Запрашиваемые ремонтные работы"
          />
          <base-btn
            color="primary"
            target="_blank"
            block
            class="mb-10 mt-2"
            large
            @click="sendRequest()"
          >
            Отправить
          </base-btn>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <center>
            <v-img
              :src="require('@/assets/rep.svg')"
              max-width="200px"
            />
          </center>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import axios from 'axios'
  import 'sweetalert2/dist/sweetalert2.css'
  export default {
    name: 'BaseContactForm',
    inject: ['theme'],

    props: {
      subtitle: String,
      title: {
        type: String,
        default: null,
      },
    },
    data: () => ({
      contract_number: null,
      comment: null,
    }),
    methods: {
      sendRequest () {
        if (this.contract_number && this.comment) {
          var data = {
            contract_number: this.contract_number,
            comment: this.comment,
          }
          var self = this
          axios.post('https://ibc.kz/app/repair-request/send', data).then(
            function (response) {
              if (response.data) {
                self.$swal('Успешно', 'Ваша заявка отправлена. В ближайшее время мы Вам обязательно перезвоним', 'success')
                self.$emit('close')
                self.contract_number = null
                self.comment = null
              } else {
                self.$swal('Ошибка', 'Договор не найден. Попробуйте ещё раз', 'error')
              }
            },
          )
        }
      },
    },
  }
</script>
